var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.27273C25 6.77123 24.8055 6.29027 24.4593 5.93565C24.1131 5.58104 23.6435 5.38182 23.1538 5.38182H11.1538L8.93846 2.35636C8.7665 2.12152 8.54351 1.93091 8.28716 1.79963C8.03082 1.66835 7.74815 1.6 7.46154 1.6H2.84615C2.35652 1.6 1.88695 1.79922 1.54073 2.15383C1.19451 2.50845 1 2.98941 1 3.49091V20.5091C1 21.0106 1.19451 21.4915 1.54073 21.8462C1.88695 22.2008 2.35652 22.4 2.84615 22.4H23.1538C23.6435 22.4 24.1131 22.2008 24.4593 21.8462C24.8055 21.4915 25 21.0106 25 20.5091V7.27273Z",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.0a0b3d1b00cee140d5fe714996e1a7a2.svg";
export { ForwardRef as ReactComponent };